import { BillingStatusType } from '~globals/types/enums';

export const BILLING_STATUS_DESCRIPTIONS = [
  {
    billingStatusType: BillingStatusType.NoFee,
    description: 'Sin tarifar',
  },
  {
    billingStatusType: BillingStatusType.Fee,
    description: 'Tarifado',
  },
  {
    billingStatusType: BillingStatusType.Settled,
    description: 'Liquidado',
  },
];
